export default __webpack_public_path__ + "static/media/plus-gray.1372b3b4.svg";